import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { routes } from "./routing/AppRouter";
import { AppLayout } from "./shared/layout/AppLayout";
import LoadingBox from "./shared/LoadingBox";

const router = createBrowserRouter(routes);

function App() {
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
      fallbackElement={
        <AppLayout>
          <LoadingBox />
        </AppLayout>
      }
    />
  );
}

export default App;
